module.exports = __webpack_public_path__ + "static/media/expand-icon.72b694f0.svg";